import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';

import { SocietyCorporateId } from 'types/Society';
import { hasUnlimitedVersion } from 'utils/hasUnlimitedVersion';
import { configsByCorporateId } from 'modules/_custom/config/configsByCorporateId';

import MenuItem from './MenuItem';

type Props = {
  order: string;
  societyId: string;
  corporateId: SocietyCorporateId;
  getBoardLinkByRole: () => string;
  isActive: boolean;
};

const BoardsMenu: FC<Props> = ({
  order,
  societyId,
  corporateId,
  getBoardLinkByRole,
  isActive,
}) => {
  const { t } = useTranslate();

  const config = configsByCorporateId[corporateId];

  return (
    <>
      <Accordion.Toggle as={Button} variant="link" eventKey={order}>
        <li className={`nk-menu-item has-sub ${isActive ? 'active' : ''}`}>
          <a className="nk-menu-link nk-menu-toggle">
            <span className="nk-menu-icon">
              <em className="icon ni ni-chat-circle" />
            </span>
            <span className="nk-menu-text">{t('BoardCouncil')}</span>
          </a>
        </li>
      </Accordion.Toggle>

      <Accordion.Collapse eventKey={order}>
        <ul className="nk-menu-sub">
          {config?.hasBasicBoardEntityType ? (
            <MenuItem linkTo={`/juntas-basicas/${societyId}`} text="Boards" />
          ) : (
            <MenuItem
              linkTo={getBoardLinkByRole()}
              text="Boards"
              disabled={!hasUnlimitedVersion()}
            />
          )}
        </ul>
      </Accordion.Collapse>
    </>
  );
};

export default BoardsMenu;
